import { EmptyArray } from 'lib/array/arrayUtils'
import useMerchandiseBrandsList from './useMerchandiseBrandsList'
import useMerchandiseBrands from './useMerchandiseBrands'

type ReturnType = [
  Array<App.MerchandiseBrand>,
  boolean,
  any,
]

function useMerchandiseTopBrands(): ReturnType {
  const [topBrandIds, fetchingTopBrandsList] = useMerchandiseBrandsList({
    sortBy: 'top',
    limit: 6,
  })

  const [topBrands, fetchingTopBrands, error] = useMerchandiseBrands(topBrandIds)

  return [
    topBrands ?? EmptyArray,
    (fetchingTopBrandsList || fetchingTopBrands) ?? false,
    error ?? undefined,
  ]
}

export default useMerchandiseTopBrands
